export default class BasePriceBinder {
	id;
	title;
	calculator;
	summaryDisplayer;
	priceFormatter;

	baseElement;
	fieldWrapper;
	isActive = false;
	isEnabled = true;
	currentPrice = 0;
	optionId;

	constructor(id, title, calculator, summaryDisplayer, priceFormatter) {
		this.id = id;
		this.title = title;
		this.calculator = calculator;
		this.summaryDisplayer = summaryDisplayer;
		this.priceFormatter = priceFormatter;
		this.optionId = id;
		this.fieldWrapper = document.getElementById(id + '_field');
	}

	initEvents() {
		jQuery(this.fieldWrapper).on(
			'fpf-field-display-toggle',
			(e, enabled) => {
				if (this.isEnabled !== enabled) {
					this.isEnabled = enabled;
					this.handleChange();
				}
			}
		);
	}

	handleChange() {
		const price = this.calculator.getPrice();
		if (price !== this.currentPrice) {
			this.currentPrice = price;
			this.updateFieldPrice();
		}

		if (this.isActive && this.isEnabled) {
			this.summaryDisplayer.set(this.optionId, {
				title: this.title,
				price: this.calculator.getSummaryPrice(),
			});
		} else {
			this.summaryDisplayer.remove(this.optionId);
		}

		this.summaryDisplayer.display(this.calculator.getProductPrice());
	}

	handleCalculatorChange(params) {
		this.calculator.setParams(params);
		this.handleChange();
	}

	updateFieldPrice() {
		const selector = `${this.optionId}_price`;
		const element = document.getElementById(selector);
		if (element) {
			element.textContent = `(${this.priceFormatter.format(this.currentPrice)})`;
		}
	}
}
